// Phase 6D — shared one-click actions for the Opportunities Today Worklist
// and Priority Queue. Reuses only the existing generic Company PATCH +
// Activity endpoints; no new backend routes, no separate task database.

export const ACTIONS = [
  { key: 'log_outreach', label: 'Log Outreach' },
  { key: 'no_response', label: 'No Response Yet' },
  { key: 'positive_response', label: 'Positive Response' },
  { key: 'discovery_needed', label: 'Discovery Needed' },
  { key: 'follow_up_later', label: 'Follow Up Later' },
  { key: 'not_interested', label: 'Not Interested' },
  { key: 'agreement_opportunity', label: 'Mark Agreement Opportunity' },
  { key: 'needs_enrichment', label: 'Needs Enrichment' },
  { key: 'no_dm', label: 'No Decision Maker Found' },
];

const todayPlus = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export async function runOpportunityAction(API_URL, fetchWithAuth, opp, actionKey, extra = {}) {
  const patch = {};
  let activity = null;

  switch (actionKey) {
    case 'log_outreach':
      if (opp.pipeline_stage === 'Prospect') patch.pipeline_stage = 'Outreach';
      activity = 'Outreach logged';
      break;
    case 'no_response': {
      const resched = todayPlus(3);
      patch.next_action = 'Follow up';
      patch.next_action_due_date = resched;
      activity = `No response yet — checked in, follow-up rescheduled to ${resched}`;
      break;
    }
    case 'positive_response':
      patch.pipeline_stage = 'Response';
      patch.last_response_status = 'Positive';
      patch.last_response_at = new Date().toISOString();
      patch.next_action = null;
      patch.next_action_due_date = null;
      activity = 'Positive response received';
      break;
    case 'discovery_needed':
      patch.pipeline_stage = 'Discovery';
      patch.last_response_status = 'Discovery Needed';
      patch.next_action = null;
      patch.next_action_due_date = null;
      activity = 'Discovery needed — moving to Discovery stage';
      break;
    case 'follow_up_later':
      if (!extra.date) throw new Error('Pick a follow-up date');
      patch.next_action = 'Follow up';
      patch.next_action_due_date = extra.date;
      activity = `Follow-up rescheduled for ${extra.date}`;
      break;
    case 'not_interested':
      patch.pipeline_stage = 'Lost / Closed';
      patch.account_status = 'Lost';
      patch.last_response_status = 'Not Interested';
      patch.next_action = null;
      patch.next_action_due_date = null;
      activity = 'Marked Not Interested — closed';
      break;
    case 'agreement_opportunity':
      patch.pipeline_stage = 'Agreement Sent';
      activity = 'Agreement opportunity identified';
      break;
    case 'needs_enrichment':
      activity = 'Flagged: needs decision-maker enrichment';
      break;
    case 'no_dm':
      activity = 'No decision maker found';
      break;
    default:
      return;
  }

  if (Object.keys(patch).length) {
    await fetchWithAuth(`${API_URL}/api/crm/companies/${opp.id}`, {
      method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(patch),
    });
  }
  if (activity) {
    await fetchWithAuth(`${API_URL}/api/crm/companies/${opp.id}/activities`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: activity, activity_type: 'outreach' }),
    });
  }
}
